import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), senha);
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(errorMessage(err, "Falha ao entrar"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] px-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-10 justify-center">
          <img src="/connect-icon.svg" alt="" className="h-8 w-8" />
          <div className="text-left">
            <p className="text-[10px] font-semibold tracking-widest leading-none salonup-logo-badge">SalonUp</p>
            <h1 className="text-2xl font-bold tracking-tight text-zinc-50 leading-tight">CONNECT</h1>
          </div>
        </div>
        <div className="bg-[#111113] border border-zinc-800 rounded-xl p-6">
          <h2 className="text-lg font-semibold text-zinc-50 mb-1">Entrar</h2>
          <p className="text-xs text-zinc-500 mb-5">Acesse o painel do seu salão</p>
          <form onSubmit={submit} className="space-y-3">
            <div>
              <Label className="text-xs">E-mail</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-9 text-sm" placeholder="voce@salao.com" />
            </div>
            <div>
              <Label className="text-xs">Senha</Label>
              <Input data-testid="login-senha" type="password" value={senha} onChange={(e) => setSenha(e.target.value)} required className="h-9 text-sm" placeholder="••••••" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-amber-500 text-zinc-950 hover:bg-amber-600 h-9 text-sm font-semibold mt-2">
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>
          <p className="text-xs text-zinc-500 mt-5 text-center">
            Novo por aqui? <Link to="/registrar" className="text-amber-400 hover:text-amber-300" data-testid="link-register">Cadastre seu salão</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
